module.exports = __webpack_public_path__ + "kpz.b9754720544ae52457e19af465a795f5.png";